import React from "react";
import PrimarySearch from "./primarySearch";
import DateSelect from "./dateSelect";
import DownloadButton from "./DownloadButton";
export default function PrimaryHeader({
  isSearchEnabled,
  isDownloadButton,
  placeholder,
  searchHeaderLable,
  isCalenderEnabled,
  selectOption,
  setSelectOption,
  exportCSV,
  exportExcel,
  exportPdf,
  show,
  setShow,
  onDateRangeChange = () => { },
  onChange = () => { },

}) {

  const onDownloadClick = () => {

  }
  return (
    <div className="search-header-holder">
      <div className="search-header">
        <div className="table-sec-calendar">
          <div className="align-items-center flex h-2rem  font-size-xl">
            {searchHeaderLable && <span>{searchHeaderLable}</span>}
          </div>
        </div>

    
        <div className="search-btn-sec">
          {isCalenderEnabled && (
            <DateSelect
              isShow={true}
              show={show}
              setShow={setShow}
              selectOption={selectOption}
              setSelectOption={setSelectOption}
              onDateRangeChange={onDateRangeChange}
            />
          )}
        </div>


        <div className="search-btn-sec">
          {isDownloadButton && (
            <DownloadButton onClick={onDownloadClick}
              exportCSV={exportCSV}
              exportExcel={exportExcel}
              exportPdf={exportPdf}
            />
          )}
          {isSearchEnabled && <PrimarySearch onChange={onChange} searchPlaceHolder={placeholder} />}
        </div>
      </div>
    </div>
  );
}